module.exports = __webpack_public_path__ + "img/16_lisa_s.ab3a4b6a.png";